import _ from 'lodash';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  Button, FormGroup, Label, FormText, Row, Col,
} from 'reactstrap';
import { Field, reduxForm, formValueSelector } from 'redux-form';
import {
  Required, required, toNumber, renderInput,
} from '../../helpers/formHelper';

class View extends Component {
  constructor(props) {
    super(props);
    this.initialStudentStatusCampRentals = props.displays.initial_student_status_camp_rentals;
  }

  // initialStudentStatusCampRentals.idをhidden fieldに追加
  // initialStudentStatusCampRentals.lengthより小さい場合、idはnew
  // initialStudentStatusCampRentalsがrentals.lengthより大きい場合、差の分のidに_destroyを追加
  renderStudentStatusCampRentalId() {
    const { rentals } = this.props;
    const max = Math.max(rentals.length, this.initialStudentStatusCampRentals.length);
    return _.range(max).map((i) => (
      <React.Fragment key={i}>
        <Field name={`parent_status[student_statuses_attributes][0][student_status_camp_rentals_attributes][${i}][id]`} type="hidden" component="input" value={this.initialStudentStatusCampRentals[i] ? this.initialStudentStatusCampRentals[i].id : 'new'} />
        {this.initialStudentStatusCampRentals[i] && i >= rentals.length && <input name={`parent_status[student_statuses_attributes][0][student_status_camp_rentals_attributes][${i}][_destroy]`} type="hidden" value="1" />}
      </React.Fragment>
    ));
  }

  renderRentals() {
    const {
      displays, pcRentalSelected, rentals, pcTypes, linkSvgPath, isEdit,
    } = this.props;
    if (displays.is_pc_all_rental) {
      return <Field name="parent_status[student_statuses_attributes][0][pc_rental]" type="hidden" component="input" />;
    }

    return (
      <>
        {isEdit && this.renderStudentStatusCampRentalId()}
        {
          (rentals.length > 0 && rentals.map((rental, index) => (
            <React.Fragment key={rental.id}>
              <FormGroup>
                <Label>
                  {rental.name}
                  {rental.strings.title}
                </Label>
                <Required />
                <Field name={`parent_status[student_statuses_attributes][0][student_status_camp_rentals_attributes][${index}][camp_rental_id]`} type="hidden" component="input" value={rental.id} />
                <br />
                {rental.strings.description && (
                  <p className="camp-rental-description">{rental.strings.description}</p>
                )}
                {rental.canOwn && (
                <FormGroup inline check>
                  <Field
                    type="radio"
                    value="false"
                    component={renderInput}
                    validate={[required]}
                    name={`parent_status[student_statuses_attributes][0][student_status_camp_rentals_attributes][${index}][use_rental]`}
                    label={rental.strings.own}
                    id={`use_rental${index}_0`}
                    disabled={rental.name === 'AdobeCC' && pcRentalSelected}
                  />
                  {' '}
                </FormGroup>
                )}
                <FormGroup inline check>
                  <Field
                    type="radio"
                    value="true"
                    component={renderInput}
                    validate={[required]}
                    name={`parent_status[student_statuses_attributes][0][student_status_camp_rentals_attributes][${index}][use_rental]`}
                    label={rental.canOwn ? rental.strings.rental : 'レンタル必須'}
                    id={`use_rental${index}_1`}
                    disabled={rental.name === 'AdobeCC' && pcRentalSelected}
                  />
                  {' '}
                </FormGroup>
                {rental.name === 'AdobeCC' && pcRentalSelected && <Field name={`parent_status[student_statuses_attributes][0][student_status_camp_rentals_attributes][${index}][use_rental]`} type="hidden" component="input" value="true" />}
                {rental.strings.notes?.map((note) => (
                  <p className="camp-rental-note" key={note.before}>
                    ※
                    {note.before}
                    {note.linkText && (note.linkUrl
                      ? <a href={note.linkUrl} target="_blank" rel="noopener noreferrer">{note.linkText}</a>
                      : <strong>{note.linkText}</strong>)}
                    {note.after}
                  </p>
                ))}
              </FormGroup>
              {rental.isPc && !pcRentalSelected ? (
                <>
                  <FormGroup>
                    <Label htmlFor={`parent_status[student_statuses_attributes][0][student_status_camp_rentals_attributes][${index}][pc_type_id]`}>ご使用PCの種類</Label>
                    <Required />
                    <Field
                      id={`parent_status_student_statuses_attributes_0_student_status_camp_rentals_attributes_${index}_pc_type_id`}
                      name={`parent_status[student_statuses_attributes][0][student_status_camp_rentals_attributes][${index}][pc_type_id]`}
                      type="select"
                      component={renderInput}
                      validate={[required]}
                      parse={toNumber}
                    >
                      <option>お選びください</option>
                      {pcTypes.map((x) => <option key={x[0]} value={x[0]}>{x[1]}</option>)}
                    </Field>
                  </FormGroup>
                  <Label>ご自身のPCを使用される方へ</Label>
                  <Row className="justify-content-center">
                    <Col xs={12} sm={8}>
                      <p>
                        ご自身のPCが必要スペックを満たしていることを必ずご確認ください。
                        <br />
                        また、ご自身のPCを使用される場合、事前設定はお客さまご自身に行っていただきます。
                      </p>
                    </Col>
                    <Col xs={6} sm={4} className="mx-auto p-0">
                      <Button
                        className="information-for-pc"
                        onClick={(e) => {
                          e.preventDefault();
                          window.open('https://docs.life-is-tech.com/pc-setting');
                        }}
                      >
                        必要スペックはこちら
                        <img src={linkSvgPath} height="12" width="12" alt=">>" />
                      </Button>
                    </Col>
                  </Row>
                </>
              ) : (
                <Field name={`parent_status[student_statuses_attributes][0][student_status_camp_rentals_attributes][${index}][pc_type_id]`} type="hidden" component="input" />
              )}
              {rental.name === 'AdobeCC' && (
                <>
                  <Label>Adobe CCアカウントについて</Label>
                  <Row className="justify-content-center">
                    <Col>
                      {pcRentalSelected ? (
                        <p>PCレンタルをご選択の場合、ご自身の Adobe CC アカウントを使用することはできません。予めご了承ください。</p>
                      ) : (
                        <p>
                          現在スクールにご参加中の方は、スクールでお使いのAdobe CCアカウントでご参加いただけます。
                          <br />
                          ※注：2026年10月以降にご入塾の場合、Adobe CCアカウントをお持ちでない可能性がございます。ご希望の方はスクールガイドより申請ください。
                        </p>
                      )}
                    </Col>
                  </Row>
                </>
              )}
            </React.Fragment>
          )))
        }
      </>
    );
  }

  render() {
    const {
      displays, stayPlans, courses, planStayplanMeetingTimes, payments, formValues, isEdit,
    } = this.props;

    // # TODO: initialValueのplan, courseを＊選択済と表示して選択可能にする
    return (
      <>
        <Field name="parent_status[camp_id]" type="hidden" component="input" value={displays.camp_id} />
        <FormGroup>
          <Label htmlFor="parent_status[student_statuses_attributes][0][plan_id]">場所・日時</Label>
          <Required />
          <Field
            placeholder="お選びください"
            id="parent_status_student_statuses_attributes_0_plan_id"
            name="parent_status[student_statuses_attributes][0][plan_id]"
            type="select"
            component={renderInput}
            validate={[required]}
          >
            <option>お選びください</option>
            {displays.plans.map((x) => <option key={x.id} value={x.id} disabled={x.disabled}>{x.name}</option>)}
          </Field>
        </FormGroup>
        {stayPlans.length > 0 && (
          <FormGroup>
            <Label htmlFor="parent_status[student_statuses_attributes][0][stayplan_id]">{displays.camp_id === 161 ? '前日オリエンテーション' : 'プラン'}</Label>
            <Required />
            <Field
              id="parent_status_student_statuses_attributes_0_stayplan_id"
              name="parent_status[student_statuses_attributes][0][stayplan_id]"
              type="select"
              component={renderInput}
              validate={[required]}
              parse={toNumber}
            >
              <option>お選びください</option>
              {stayPlans.map((x) => <option key={x.stayplanId} value={x.stayplanId}>{x.name}</option>)}
            </Field>
          </FormGroup>
        )}
        {planStayplanMeetingTimes.length > 0 && (
          <FormGroup>
            <Label htmlFor="parent_status[student_statuses_attributes][0][meeting_time]">集合時間</Label>
            <Required />
            <Field
              id="parent_status_student_statuses_attributes_0_meeting_time"
              name="parent_status[student_statuses_attributes][0][meeting_time]"
              type="select"
              component={renderInput}
              validate={[required]}
            >
              <option>お選びください</option>
              {planStayplanMeetingTimes.map((x) => <option key={x} value={x}>{x}</option>)}
            </Field>
          </FormGroup>
        )}
        {courses.length > 0 && (
          <FormGroup>
            <Label htmlFor="parent_status[student_statuses_attributes][0][course_id]">参加するコース</Label>
            <Required />
            <Field
              id="parent_status_student_statuses_attributes_0_course_id"
              name="parent_status[student_statuses_attributes][0][course_id]"
              type="select"
              component={renderInput}
              validate={[required]}
              parse={toNumber}
            >
              <option>お選びください</option>
              {courses.map((x) => <option key={x.courseId} value={x.courseId} disabled={x.capacityStatus === 'full' || x.status === 'closed'}>{x.name}</option>)}
            </Field>
            {
              formValues.parent_status?.student_statuses_attributes?.[0]?.course_id === 29 && (
                <FormText>※AIクリエイティブコースでは、使用するツールの利用規約上、13歳以上の方がご参加可能です。13歳未満の方は、他コースをお選びください。</FormText>
              )
            }
          </FormGroup>
        )}
        {!isEdit && !displays.is_free && payments.length > 0 && (
          <FormGroup>
            <Label htmlFor="parent_status[payment_id]">お支払い方法</Label>
            <Required />
            <Field
              id="parent_status_payment_id"
              name="parent_status[payment_id]"
              type="select"
              component={renderInput}
              validate={[required]}
              parse={toNumber}
            >
              <option>お選びください</option>
              {payments.map((x) => <option key={x.id} value={x.id}>{x.displayName}</option>)}
            </Field>
            {formValues.parent_status?.payment_id === 7 && (
              <FormText color="danger">
                クレジットカードの分割回数に対応しているか、クレジットカード会社に必ずご確認ください
                <br />
                ※ 3回払いの場合、カード会社の所定の分割手数料が適用される可能性があります
              </FormText>
            )}
            {[3, 4].some((x) => x === formValues.parent_status?.payment_id) && (
              <FormText color="danger">
                ※振込手数料はお客さま負担となります。
                <br />
                ※申込後、料金変更を伴う申込内容の変更をされた場合、変更前の料金が全額返金され、再度変更後の料金のお振込みが必要となります。その場合も、振込手数料はお客さま負担となりますのでご了承ください。
              </FormText>
            )}
          </FormGroup>
        )}
        {this.renderRentals()}
      </>
    );
  }
}

View.defaultProps = {
  pcRentalSelected: false,
  isEdit: false,
};

View.propTypes = {
  formValues: PropTypes.shape({
    authenticity_token: PropTypes.string,
    parent_status: PropTypes.shape({
      camp_id: PropTypes.number,
    }),
  }).isRequired,
  displays: PropTypes.shape({
    camp_id: PropTypes.number.isRequired,
    plans: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
      disabled: PropTypes.bool,
    })),
    logged_in: PropTypes.bool.isRequired,
    is_free: PropTypes.bool.isRequired,
    free_message: PropTypes.string,
    is_pc_all_rental: PropTypes.bool.isRequired,
  }).isRequired,
  stayPlans: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number,
    shortName: PropTypes.string,
  })).isRequired,
  courses: PropTypes.arrayOf(PropTypes.shape({
    courseId: PropTypes.number,
    name: PropTypes.string,
    status: PropTypes.string,
    capacityStatus: PropTypes.string,
  })).isRequired,
  planStayplanMeetingTimes: PropTypes.arrayOf(PropTypes.string).isRequired,
  payments: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number,
    displayName: PropTypes.string,
  })).isRequired,
  rentals: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number,
    canOwn: PropTypes.bool,
    isPc: PropTypes.bool,
    name: PropTypes.string,
    price: PropTypes.number,
    strings: PropTypes.shape({
      own: PropTypes.string,
      rental: PropTypes.string,
      requiredRental: PropTypes.string,
      title: PropTypes.string,
      description: PropTypes.string,
      notes: PropTypes.arrayOf(PropTypes.shape({
        before: PropTypes.string,
        linkText: PropTypes.string,
        linkUrl: PropTypes.string,
        after: PropTypes.string,
      })),
    }),
  })).isRequired,
  // TODO: 最悪の型なので後でAPI事新規設計
  pcTypes: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
  ]))).isRequired,
  pcRentalSelected: PropTypes.bool,
  isEdit: PropTypes.bool,
  linkSvgPath: PropTypes.string.isRequired,
};

const selector = formValueSelector('campEntryCamp');
export default reduxForm({
  form: 'campEntryCamp',
  validate: () => {
    const errors = {};
    return errors;
  },
})(connect((state) => ({
  plans: state.campEntry.plans,
  stayPlans: state.campEntry.stayPlans,
  courses: state.campEntry.courses,
  planStayplanMeetingTimes: state.campEntry.planStayplanMeetingTimes,
  payments: state.campEntry.payments,
  rentals: state.campEntry.rentals,
  pcTypes: state.campEntry.pcTypes,
  formValues: selector(
    state,
    'authenticity_token',
    'any_code',
    'parent_status[id]',
    'parent_status[camp_id]',
    'parent_status[payment_id]',
    'parent_status[student_statuses_attributes][0][plan_id]',
    'parent_status[student_statuses_attributes][0][stayplan_id]',
    'parent_status[student_statuses_attributes][0][course_id]',
    'parent_status[student_statuses_attributes][0][student_status_camp_rentals_attributes][0][id]',
    'parent_status[student_statuses_attributes][0][student_status_camp_rentals_attributes][0][camp_rental_id]',
    'parent_status[student_statuses_attributes][0][student_status_camp_rentals_attributes][0][use_rental]',
    'parent_status[student_statuses_attributes][0][student_status_camp_rentals_attributes][0][pc_type_id]',
    'parent_status[student_statuses_attributes][0][student_status_camp_rentals_attributes][1][id]',
    'parent_status[student_statuses_attributes][0][student_status_camp_rentals_attributes][1][use_rental]',
    'parent_status[student_statuses_attributes][0][student_status_camp_rentals_attributes][1][camp_rental_id]',
  ),
  pcRentalSelected: selector(state, 'parent_status[student_statuses_attributes][0][student_status_camp_rentals_attributes][0][use_rental]') === 'true',
  prices: state.campEntry.prices,
}), () => ({
}))(View));
